var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-ad-page"},[_c('create-ad-wizard',{attrs:{"edit-ad-id":_vm.editAdId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }